<script setup lang="ts">
import { ref } from 'vue'

defineProps<{
  isOpen: boolean
}>()

defineEmits<{
  (e: 'close'): void
}>()

const notifications = ref<any[]>([])
</script>

<template>
  <div 
    v-if="isOpen"
    class="fixed inset-0 bg-black bg-opacity-50 z-50"
    @click="$emit('close')"
  >
    <div 
      class="absolute right-0 top-0 bottom-0 w-96 bg-white dark:bg-black shadow-lg"
      @click.stop
    >
      <div class="p-4 border-b border-gray-100 dark:border-gray-800 flex justify-between items-center">
        <h2 class="text-lg font-semibold text-gray-800 dark:text-white">Notifications</h2>
        <button 
          @click="$emit('close')"
          class="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
        >
          ✕
        </button>
      </div>
      
      <div class="overflow-y-auto h-full pb-20" v-if="notifications.length > 0">       
        <div 
          v-for="notification in notifications" 
          :key="notification.id"
          class="p-4 border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-900"
        >
          <div class="flex justify-between items-start mb-1">
            <h3 class="font-medium text-gray-800 dark:text-white">{{ notification.title }}</h3>
            <span class="text-xs text-gray-500 dark:text-gray-400">{{ notification.time }}</span>
          </div>
          <p class="text-sm text-gray-600 dark:text-gray-300">{{ notification.message }}</p>
        </div>
      </div>
       <div class="p-4 text-gray-500 dark:text-gray-400" v-if="notifications.length === 0">
          No notifications available.
          </div>
    </div>
  </div>
</template>